var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Html5Qrcode } from 'html5-qrcode';
export function startScanner(containerId, onSuccess, onError) {
    return __awaiter(this, void 0, void 0, function* () {
        const scanner = new Html5Qrcode(containerId);
        yield scanner.start({ facingMode: 'environment' }, {
            fps: 10,
            qrbox: { width: 250, height: 250 },
        }, (decodedText) => {
            onSuccess(decodedText);
        }, () => { });
        return scanner;
    });
}
export function stopScanner(scanner) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield scanner.stop();
        }
        catch (_a) {
            // Scanner may already be stopped
        }
    });
}
